"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientUtils = void 0;
const printName = (client) => {
    return (client === null || client === void 0 ? void 0 : client.name) + "XYZ";
};
const fullAdressAsHTML = (client) => {
    var _a;
    const html = `
    ${(client === null || client === void 0 ? void 0 : client.companyName) || (client === null || client === void 0 ? void 0 : client.name)}\n
    ${client === null || client === void 0 ? void 0 : client.address}\n
    ${client === null || client === void 0 ? void 0 : client.zip} ${client === null || client === void 0 ? void 0 : client.city}\n
    ${(_a = client === null || client === void 0 ? void 0 : client.country) === null || _a === void 0 ? void 0 : _a.name}
  `;
    return html;
};
exports.clientUtils = {
    printName,
    fullAdressAsHTML,
};
//# sourceMappingURL=clientUtils.js.map